import { render, staticRenderFns } from "./PremiumComponent.vue?vue&type=template&id=04fd380a&"
import script from "./PremiumComponent.vue?vue&type=script&lang=js&"
export * from "./PremiumComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports